<template>
  <div>
    <v-row v-if="images.length">
      <v-col cols="12" xs="12">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col
                v-for="image in images"
                :key="image.src"
                class="d-flex child-flex"
                cols="4"
              >
                <v-card flat tile class="d-flex">
                  <v-img
                    :src="image.src"
                    :lazy-src="`https://picsum.photos/10/6?image=1`"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="editable">
      <v-col cols="12" class="pr-6">
        <v-file-input
          v-model="files"
          color="primary accent-4"
          counter
          label="Images"
          multiple
          dense
          placeholder="Add images"
          prepend-icon="mdi-paperclip"
          outlined
          @change="$emit('update:files', files)"
          :show-size="1000"
        >
          <template v-slot:selection="{ index, text }">
            <v-chip v-if="index < 2" color="primary accent-4" dark label small>
              {{ text }}
            </v-chip>
            <span
              v-else-if="index === 2"
              class="overline grey--text text--darken-3 mx-2"
            >
              +{{ files.length - 2 }} File(s)
            </span>
          </template>
        </v-file-input>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ImagesContainer",
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      files: [],
    };
  },
};
</script>
